import { ICommunity, ICourseLike, ILessonKeepWatching } from 'interface/course';
import { get, post } from 'services/api';

import { API_V4_BASE_URL } from 'settings';
import { toastError } from 'utils/reduxToast';
import { withLoader } from 'utils/reduxLoader';

class Course {
  public like(courseHash: string): Promise<ICourseLike> {
    const request = post({
      url: `/learner/course/${courseHash}/like`,
      baseURL: API_V4_BASE_URL,
    }).then((response) => response.data);

    return withLoader(request);
  }

  public setAcceptedTerm(courseHash: string, accepted: boolean): Promise<void> {
    return post({
      url: `/learner/course/${courseHash}/accept-terms`,
      data: { accepted },
    }).then((response) => response.data);
  }

  public getCertificateUrl(courseHash: string): Promise<string> {
    return get({ url: `/course/${courseHash}/certificate`, baseURL: API_V4_BASE_URL }).then(
      (response) => response.data.data.certificate?.url || null
    );
  }

  public getCustomizations(courseHash: string): Promise<any> {
    return get({ url: `/learner/course/${courseHash}/customization?` }).then((response) => response.data);
  }

  public register(courseHash: string) {
    const request = post({ url: `/learner/course/${courseHash}/register` }).catch(() => {
      toastError('Um erro aconteceu...');
    });

    return withLoader(request);
  }

  public getKeepWatching(courseHash: string): Promise<ILessonKeepWatching> {
    return get({ url: `/learner/course/${courseHash}/last-lesson-watched`, baseURL: API_V4_BASE_URL }).then(
      (response) => response.data.data
    );
  }

  public getCommunityUrl(courseHash: string): Promise<ICommunity> {
    return get({ url: `/learner/communities/${courseHash}`, baseURL: API_V4_BASE_URL }).then(
      (response) => response.data
    );
  }
}

export default new Course();
